const NbciInvoiceResponseApiUrls = {
  GET: `${process.env.REACT_APP_USER_NBCI_URL}/nbci/response/get`, 
};

export default NbciInvoiceResponseApiUrls
